import type { NormalizedRace } from 'src/store/types'
import type { RaceDTO } from 'src/services/supabase/queries'
import type { Race, LightningBoostType } from '../../domain/Race'
import type { Tables } from '../../infra/supabase/database.types'
import { RaceEventMap } from '../RaceEventMap'

export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>

type RaceTableWithLightning = Tables<'race'> & {
  is_lightning_round?: boolean
  lightning_boost_type?: string | null
  lightning_boost_percent?: number | null
  lightning_boosted_items?: string[] | null
}

export const fromRaceDTO = (race: RaceDTO): Race => {
  return {
    uuid: race.id,
    createdAt: race.created_at,
    round: race.round,
    raceConfigurationId: race.race_configuration_id,
    raceEvents: race.race_event.map(RaceEventMap.fromRaceEventRowDTO),
    isLightningRound: race.is_lightning_round ?? false,
    lightningBoostType: (race.lightning_boost_type as LightningBoostType) ?? null,
    lightningBoostPercent: race.lightning_boost_percent ?? null,
    lightningBoostedItems: race.lightning_boosted_items ?? null
  }
}

export const fromRaceRowDTO = (
  raceRow: RaceTableWithLightning,
  raceEventIds?: string[]
): NormalizedRace => {
  return {
    id: raceRow.id,
    round: raceRow.round,
    createdAt: raceRow.created_at,
    raceConfigurationId: raceRow.race_configuration_id,
    raceEventIds: raceEventIds ?? [],
    isLightningRound: raceRow.is_lightning_round ?? false,
    lightningBoostType: (raceRow.lightning_boost_type as LightningBoostType) ?? null,
    lightningBoostPercent: raceRow.lightning_boost_percent ?? null,
    lightningBoostedItems: raceRow.lightning_boosted_items ?? null
  }
}
